import { apiClient } from '@borradh-workspace/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useDeleteConversation = (options?: {
  onSuccess?: () => void;
  /** Bulk delete raises one summary toast instead of one per thread. */
  showSuccessToast?: boolean;
  showErrorToast?: boolean;
}) => {
  const queryClient = useQueryClient();
  const { showSuccessToast = true, showErrorToast = true } = options ?? {};

  const mutation = useMutation({
    mutationFn: (id: string) => apiClient.delete(`conversations/${id}`),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['conversations'] });
      if (showSuccessToast) toast.success('Conversation deleted');
      options?.onSuccess?.();
    },
    onError: (error: Error) => {
      if (showErrorToast) {
        toast.error(error.message || 'Failed to delete conversation');
      }
    },
  });

  return {
    deleteConversation: mutation.mutate,
    deleteConversationAsync: mutation.mutateAsync,
    isDeleting: mutation.isPending,
  };
};
